import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {EquipeDto} from '../model/equipe.dto';
import {NouveauMembreDto} from '../model/nouveau-membre.dto';

@Injectable({
	providedIn: 'root'
})
export class EquipeService {

	private url = '/ws/equipes';

	constructor(private http: HttpClient) {
	}

	recupererEquipeParResponsable(loginResponsable: string): Observable<EquipeDto> {
		const params = new HttpParams()
			.set('loginResponsable', loginResponsable);
		return this.http.get<EquipeDto>(this.url, {params: params});
	}

	creerEquipe(equipeDto: EquipeDto): Observable<EquipeDto> {
		return this.http.post<EquipeDto>(this.url, equipeDto);
	}

	mettreAJourNomEquipe(equipeId: number, nomEquipe: string): Observable<EquipeDto> {
		const params = new HttpParams()
			.set('use-case', 'modifier-nom-equipe');
		return this.http.put<EquipeDto>(`${this.url}/${equipeId}`, nomEquipe, {params: params});
	}

	ajouterUtilisateur(equipeId: number, nouveauMembre: NouveauMembreDto): Observable<EquipeDto> {
		const params = new HttpParams()
			.set('use-case', 'ajouter-utilisateur');
		return this.http.put<EquipeDto>(`${this.url}/${equipeId}`, nouveauMembre, {params: params});
	}

	retirerUtilisateur(equipeId: number, utilisateurs: string[]): Observable<EquipeDto> {
		const params = new HttpParams()
			.set('use-case', 'retirer-utilisateurs');
		return this.http.put<EquipeDto>(`${this.url}/${equipeId}`, utilisateurs, {params: params});
	}

	/**
	 * Met à jour les zones de travail autorisées de l'équipe.
	 *
	 * @param equipeId l'id de l'équipe.
	 * @param zonesDeTravailIds les zones de travail autorisées pour l'équipe.
	 */
	modifierZoneDeTravailAutorisees(equipeId: number, zonesDeTravailIds: number[]): Observable<void> {
		const params = new HttpParams()
			.set('use-case', 'modifier-zones-autorisees');
		return this.http.put<void>(`${this.url}/${equipeId}`, zonesDeTravailIds, {params: params});
	}

	/**
	 * Récupère toutes les équipes selon le rôle de l'utilisateur.
	 *
	 * @param loginMembre le login de l'utilisateur.
	 */
	recupererEquipesSelonRoleUtilisateur(loginMembre: string): Observable<EquipeDto[]> {
		const params = new HttpParams()
			.set('loginMembre', loginMembre)
			.set('use-case', 'equipes-selon-role-utilisateur');
		return this.http.get<EquipeDto[]>(this.url, {params: params});
	}
}
